export enum ClientType {
	ALL = 'all',
	IP = 'ip',
	COMPANY = 'company',
}
